import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import {
  createRecord,
  deleteRecordById,
  getAllRecords,
  getRecordByEnrollmentandRecordTypeID,
  getRecordById,
  updateRecordById,
  upsertRecord,
} from './recordApi';

export const useCreateRecord = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['create_record'],
    mutationFn: createRecord,
    onSuccess: () => {
      toast.success('Record created successfully');
      queryClient.invalidateQueries(['records']);
    },
    onError: (error) => {
      console.log(error.response.data.message);
      toast.error(error.response.data.message);
    },
  });
};

export const useUpsertRecord = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['upsert_record'],
    mutationFn: upsertRecord,
    onSuccess: () => {
      toast.success('Record transacted successfully');
      queryClient.invalidateQueries(['records']);
    },
    onError: (error) => {
      console.log(error.response.data.message);
      toast.error(error.response.data.message);
    },
  });
};

export const useGetAllRecords = () => {
  return useQuery({
    queryKey: ['records'],
    queryFn: getAllRecords,
    onError: (error) => {
      console.error('Failed to fetch records:', error);
      toast.error(
        'Failed to fetch records: ' + (error.message || 'Unknown error')
      );
    },
  });
};

export const useGetRecordById = (recordId) => {
  return useQuery({
    queryKey: ['records', recordId],
    queryFn: () => getRecordById(recordId),
    onError: (error) => {
      console.error('Failed to fetch record:', error);
      toast.error(
        'Failed to fetch record: ' + (error.message || 'Unknown error')
      );
    },
  });
};

export const useGetRecordByEnrollmentID = (enrollmentId, recordTypeId) => {
  return useQuery({
    queryKey: ['records', 'enrollment&recordType', enrollmentId, recordTypeId],
    queryFn: () =>
      getRecordByEnrollmentandRecordTypeID([enrollmentId, recordTypeId]),
    onError: (error) => {
      console.error('Failed to fetch record:', error);
      toast.error(
        'Failed to fetch record: ' + (error.message || 'Unknown error')
      );
    },
  });
};

export const useUpdateRecordbyId = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateRecordById,
    mutationKey: ['updateRecordbyId'],
    onSuccess: () => {
      toast.success('Successfully updated record');
      queryClient.invalidateQueries(['records']);
    },
    onError: (err) => {
      console.log(err);
      toast.error(
        'Failed to update record: ' + (err.message || 'Unknown error')
      );
    },
  });
};

export const useDeleteRecordbyId = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteRecordById,
    mutationKey: ['deleteRecordbyId'],
    onSuccess: () => {
      toast.success('Successfully deleted record');
      queryClient.invalidateQueries(['records']);
    },
    onError: (err) => {
      console.log(err);
      toast.error(
        'Failed to delete record: ' + (err.message || 'Unknown error')
      );
    },
  });
};
